import React, { useState, useEffect } from "react";
import QRCode from "react-qr-code";
import AuthNavBar from "./components/nav/AuthNav";
import CryptoJS from "crypto-js";
import { useTranslation } from "react-i18next";

const QrGenerator = () => {
  const { t } = useTranslation();
  const [sin, setSin] = useState("");
  const [citizenId, setCitizenId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [dob, setDob] = useState("");
  const [maidenName, setMaidenName] = useState("");
  const [residenceAddress, setResidenceAddress] = useState("");
  const [contactOwner, setContactOwner] = useState("");
  const [enrolmentType, setEnrolmentType] = useState("");
  const [originState, setOriginState] = useState("");
  const [gender, setGender] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [region, setRegion] = useState("");
  const [district, setDistrict] = useState("");
  const [province, setProvince] = useState("");
  const [email, setEmail] = useState("");
  const [parentFirstName, setParentFirstName] = useState("");
  const [parentLastName, setParentLastName] = useState("");
  const [parentNUI, setParentNUI] = useState("");
  const [parentDob, setParentDob] = useState("");

  const onImageDownload = () => {
    const svg = document.getElementById("QRCode");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = "QRCode";
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  useEffect(() => {
    const storedCitizenId = localStorage.getItem("citizenId");
    const storedSin = localStorage.getItem("sin");
    const storedFirstName = localStorage.getItem("firstName");
    const storedLastName = localStorage.getItem("lastName");
    const storedPhoneNumber = localStorage.getItem("phoneNumber");
    const storedCountryResidence = localStorage.getItem("placeOfBirth");
    const storedDob = localStorage.getItem("dob");
    const storedMaidenName = localStorage.getItem("maidenName");
    const storedResidenceAddress = localStorage.getItem("residenceAddress");
    const storedContactOwner = localStorage.getItem("contactOwner");
    const storedEnrolmentType = localStorage.getItem("enrolmentType");
    const storedOriginState = localStorage.getItem("originState");
    const storedGender = localStorage.getItem("gender");
    const storedTrackingId = localStorage.getItem("trackingId");
    const storedDistrict = localStorage.getItem("district");
    const storedProvince = localStorage.getItem("province");
    const storedRegion = localStorage.getItem("region");
    const storedEmail = localStorage.getItem("email");
    const storedParentFirstName = localStorage.getItem("parentFirstName");
    const storedParentLastName = localStorage.getItem("parentLastName");
    const storedParentNUI = localStorage.getItem("parentNUI");
    const storedParentDob = localStorage.getItem("parentDob");
    setSin(storedSin);
    setCitizenId(storedCitizenId);
    setFirstName(storedFirstName);
    setLastName(storedLastName);
    setPhoneNumber(storedPhoneNumber);
    setPlaceOfBirth(storedCountryResidence);
    setDob(storedDob);
    setMaidenName(storedMaidenName);
    setResidenceAddress(storedResidenceAddress);
    setContactOwner(storedContactOwner);
    setEnrolmentType(storedEnrolmentType);
    setOriginState(storedOriginState);
    setGender(storedGender);
    setTrackingId(storedTrackingId);
    setDistrict(storedDistrict);
    setProvince(storedProvince);
    setRegion(storedRegion);
    setEmail(storedEmail);
    setParentFirstName(storedParentFirstName);
    setParentLastName(storedParentLastName);
    setParentNUI(storedParentNUI);
    setParentDob(storedParentDob);
  }, []);

  const secretKey = CryptoJS.enc.Utf8.parse("B!0c0nn3t#2024B!0c0nn3t#20241234"); // Ensure 32 bytes

  const encryptData = (data) => {
    const iv = CryptoJS.lib.WordArray.random(16); // Generate a random IV
    console.log("IV");
    console.log(iv);
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey, {
      iv: iv,
    });
    return {
      iv: iv.toString(CryptoJS.enc.Base64),
      encryptedData: encrypted.toString(),
    };
  };

  const qrData = {
    citizenId,
    firstName,
    lastName,
    phoneNumber,
    dob,
    residenceAddress,
    email,
    gender,
    trackingId,
    province,
    region,
    district,
    contactOwner,
    enrolmentType,
    maidenName,
    placeOfBirth,
    parentDob,
    parentFirstName,
    parentLastName,
    parentNUI,
  };
  console.log("qrData");
  console.log(qrData);

  const encryptedResult = encryptData(qrData);
  console.log("encryptedResult");
  console.log(encryptedResult);

  // Combine IV and encrypted data for QR code
  const qrCodeData = JSON.stringify(encryptedResult);
  console.log("encryptedResult222");
  console.log(qrCodeData);

  return (
    <div>
      <AuthNavBar />
      <div className="row">
        <div className="col-md-12">
          <center className="mt-3">
            <small className="mt-3 text-danger">
              <i>{t("copy_save_id")}</i>
            </small>{" "}
            <br />
            <br />
            <QRCode
              id="QRCode"
              value={qrCodeData}
              size={456}
              viewBox={`0 0 256 256`}
            />
          </center>
        </div>
        <div className="col-md-12">
          <center className="mt-3">
            <button
              className="btn btn-success"
              type="button"
              onClick={onImageDownload}
            >{t("download_qr")}</button>
            <br />
            <small className="mt-3 text-danger">
              <i>{t("protect_qr")}</i>
            </small>
          </center>
        </div>
      </div>
    </div>
  );
};

export default QrGenerator;
